import { forwardRef, useImperativeHandle, useState } from "react";
import type { ICellEditorParams } from "ag-grid-community";
import { GroupedNumberInput } from "./GroupedNumberInput";
import {
  formatGrouped,
  groupedFromValue,
  parseGrouped,
} from "../pipelineAmounts";

/**
 * Grid editor for money amounts: shows "28,463,000" while editing and saves
 * the plain number. Typing a digit to start editing replaces the value, like
 * the standard number editor.
 */
export const AmountCellEditor = forwardRef<unknown, ICellEditorParams>(
  ({ value, eventKey, colDef, column }, ref) => {
    const [text, setText] = useState(() =>
      eventKey && /^[\d.-]$/.test(eventKey)
        ? formatGrouped(eventKey)
        : groupedFromValue(value),
    );

    useImperativeHandle(ref, () => ({
      getValue: () => parseGrouped(text),
    }));

    return (
      <GroupedNumberInput
        value={text}
        onChange={setText}
        autoFocus
        ariaLabel={colDef.headerName ?? column.getColId()}
        sx={{
          width: "100%",
          height: "100%",
          px: 1,
          fontSize: 12,
          fontFamily: '"Helvetica Neue", sans-serif',
          "& input": { textAlign: "left", p: 0 },
        }}
      />
    );
  },
);
